import * as angular from "angular";
import {IController} from "angular";

export class QueryFieldComponent implements IController {
  label: any;
  isOpen: any;
  onChange: Function;

  constructor() {
  }

  onToggleOpen() {
    this.isOpen = !this.isOpen
  }
}

angular
  .module('bringoz.admin.commons')
  .component('queryField', {
    bindings: {
      label: '<',
      isOpen: '<',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/query-field/query-field.html',
    controller: QueryFieldComponent
  });
